/* ==================================================================
   Ninja Craft Tours — Global image lightbox
   ------------------------------------------------------------------
   Any element with data-nct-lightbox="<image url>" opens a popup with
   that image. Optional data-nct-alt="<alt text>". One overlay is built
   on first use and reused everywhere (homepage gallery, product "From
   past tours" gallery, etc.). Close via ×, backdrop click, or Esc;
   focus returns to the opener; page scroll locks while open.
   Styles live in assets/nct-global.css (.nct-lightbox*).
   ================================================================== */
(function () {
  var overlay, imgEl, closeBtn, opener;

  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'nct-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Photo viewer');
    overlay.hidden = true;

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'nct-lightbox__close';
    closeBtn.setAttribute('aria-label', 'Close photo');
    closeBtn.innerHTML = '&times;';

    imgEl = document.createElement('img');
    imgEl.className = 'nct-lightbox__img';
    imgEl.alt = '';

    overlay.appendChild(closeBtn);
    overlay.appendChild(imgEl);
    document.body.appendChild(overlay);
  }

  function open(url, alt, opnr) {
    build();
    imgEl.src = url;
    imgEl.alt = alt || '';
    opener = opnr || null;
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    imgEl.src = '';
    document.documentElement.style.overflow = '';
    if (opener && opener.focus) opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nct-lightbox]');
    if (trigger) {
      e.preventDefault();
      open(trigger.getAttribute('data-nct-lightbox'), trigger.getAttribute('data-nct-alt'), trigger);
      return;
    }
    if (overlay && !overlay.hidden) {
      if (e.target === overlay || e.target.closest('.nct-lightbox__close')) close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
